import Menu from "@/components/tour/regular/menu/Menu";
import { sidebarOpenState, useRecoilValue } from "store";

const MenuWithSidebarState = (props:any) => {
    const sbIsOpen = useRecoilValue(sidebarOpenState);   
    return <Menu {...props} sbIsOpen={sbIsOpen} />
}

export default MenuWithSidebarState;